/*
 * Formularul de comandă cu plata la livrare.
 *
 * Validează în browser doar ca omul să vadă greșeala imediat. Adevărul e la
 * server: regulile de aici trebuie să dea exact aceleași verdicte ca
 * `zorvia-api/lib/validate.js`, iar un test le compară pe amândouă pe aceeași
 * tabelă de cazuri (`zorvia-api/test/theme-form.test.js`).
 *
 * Dacă modifici o regulă aici, modific-o și acolo. Altfel formularul spune
 * „e în regulă" pe un câmp pe care serverul îl respinge, iar omul apasă
 * „Comandă" și primește o eroare inexplicabilă.
 */
(function () {
  'use strict';

  /* ── Reguli partajate cu serverul ──────────────────────────────────────── */

  function normalizePhone(raw) {
    var digits = String(raw == null ? '' : raw).replace(/[^\d+]/g, '');
    if (digits === '') return null;

    var rest;
    if (digits.indexOf('+40') === 0) rest = digits.slice(3);
    else if (digits.indexOf('0040') === 0) rest = digits.slice(4);
    else if (digits.indexOf('40') === 0 && digits.length === 11) rest = digits.slice(2);
    else if (digits.charAt(0) === '0') rest = digits.slice(1);
    else return null;

    if (!/^7\d{8}$/.test(rest)) return null;
    return '+40' + rest;
  }

  function clean(v, max) {
    return String(v == null ? '' : v).replace(/\s+/g, ' ').trim().slice(0, max);
  }

  function splitName(raw) {
    var full = clean(raw, 120);
    if (full.length < 5) return null;
    var parts = full.split(' ').filter(Boolean);
    if (parts.length < 2) return null;
    return { firstName: parts[0], lastName: parts.slice(1).join(' ') };
  }

  function cleanAddress(v) {
    return String(v == null ? '' : v)
      .replace(/\r\n?/g, '\n')
      .replace(/[ \t]+/g, ' ')
      .replace(/\n{2,}/g, '\n')
      .split('\n')
      .map(function (l) { return l.trim(); })
      .filter(function (l) { return l !== ''; })
      .join('\n')
      .slice(0, 300);
  }

  /*
   * Județul e text liber. Oglinda exactă a lui `resolveCounty` din
   * `zorvia-api/lib/counties.js`: dacă cele două se despart, omul scrie ceva
   * pe care formularul îl acceptă și serverul îl respinge.
   *
   * Perechile cod->nume vin din `<datalist>`, randat de Liquid din aceeași
   * listă pe care o are serverul.
   */
  var countyCodes = [];   // ['AB','AR',...]
  var countyByName = {};  // { 'cluj': 'CJ', ... } nume normalizat -> cod

  function normalizeCounty(value) {
    return String(value == null ? '' : value)
      .replace(/ş/g, 's').replace(/Ş/g, 's')
      .replace(/ţ/g, 't').replace(/Ţ/g, 't')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }

  function resolveCounty(input) {
    if (typeof input !== 'string') return null;
    var trimmed = input.trim();
    if (trimmed === '') return null;

    var upper = trimmed.toUpperCase();
    if (countyCodes.indexOf(upper) !== -1) return upper;

    var norm = normalizeCounty(trimmed);
    if (norm === '') return null;

    // Un bucureștean scrie „Sector 3", nu „București".
    if (/^sector(ul)?[1-6]$/.test(norm) || /^s[1-6]$/.test(norm)) return 'B';

    return countyByName[norm] || null;
  }

  /** Aceleași chei de câmp ca la server, ca mesajele să se potrivească 1:1. */
  function validate(values) {
    var errors = {};
    if (!splitName(values.name)) errors.name = true;
    if (!normalizePhone(values.phone)) errors.phone = true;
    if (resolveCounty(clean(values.county, 40)) === null) errors.county = true;
    if (clean(values.city, 80).length < 2) errors.city = true;
    if (cleanAddress(values.address).length < 10) errors.address = true;
    return errors;
  }

  // Expus pentru testul care compară browserul cu serverul.
  window.ZVForm = {
    normalizePhone: normalizePhone,
    splitName: splitName,
    cleanAddress: cleanAddress,
    resolveCounty: resolveCounty,
    validate: validate,
    setCounties: function (pairs) {
      countyCodes = [];
      countyByName = {};
      (pairs || []).forEach(function (p) {
        countyCodes.push(p.code);
        countyByName[normalizeCounty(p.name)] = p.code;
      });
    }
  };

  /* ── Legarea de DOM ────────────────────────────────────────────────────── */

  function readConfig() {
    var el = document.getElementById('zv-form-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function cookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? m.pop() : null;
  }

  function param(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
      return null;
    }
  }

  /**
   * Codul de test Meta/TikTok, pornit cu `?zv_test=<cod>`. Îl citim din
   * sessionStorage pentru cazul în care omul a intrat pe pagină cu parametrul
   * și a navigat de-atunci. Vezi `tracking.js` — helperul e duplicat
   * deliberat, ca formularul să nu depindă de ordinea de încărcare.
   */
  function testCode() {
    var asked = param('zv_test');
    var valid = asked && /^[A-Za-z0-9_-]{4,64}$/.test(asked) ? asked : null;
    try {
      return valid || sessionStorage.getItem('zv_test');
    } catch (e) {
      return valid;
    }
  }

  function collectUtm() {
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
    var out = {};
    keys.forEach(function (k) {
      var v = param(k);
      if (v) out[k] = v;
    });
    return out;
  }

  function init() {
    var cfg = readConfig();
    var form = document.querySelector('[data-zv-cod-form]');
    if (!cfg || !form) return;

    var renderedAt = Date.now();

    // Sursa de adevăr pentru județe e lista randată de Liquid în <datalist>,
    // aceeași pe care o folosește și serverul.
    var dl = document.getElementById('zv-counties');
    if (dl) {
      var pairs = [];
      for (var i = 0; i < dl.options.length; i++) {
        pairs.push({ code: dl.options[i].getAttribute('data-code'), name: dl.options[i].value });
      }
      window.ZVForm.setCounties(pairs);
    }

    var button = form.querySelector('[data-zv-submit]');
    var label = form.querySelector('[data-zv-submit-label]');
    var formError = form.querySelector('[data-zv-form-error]');
    var submitting = false;

    function fieldOf(name) {
      var input = form.querySelector('[name="' + name + '"]');
      return input ? input.closest('.zv-field') : null;
    }

    function showError(name, message) {
      var slot = form.querySelector('[data-zv-error="' + name + '"]');
      var field = fieldOf(name);
      if (slot) slot.textContent = message || '';
      if (field) field.classList.toggle('is-invalid', Boolean(message));
    }

    function clearErrors() {
      ['name', 'address', 'city', 'county', 'phone', 'quantity'].forEach(function (n) {
        showError(n, '');
      });
      formError.hidden = true;
      formError.textContent = '';
    }

    function values() {
      return {
        name: form.elements.name.value,
        phone: form.elements.phone.value,
        county: form.elements.county.value,
        city: form.elements.city.value,
        address: form.elements.address.value
      };
    }

    // Validare la blur, nu la fiecare tastă: corectarea în timp real a unui
    // câmp pe jumătate scris citește ca o cicăleală.
    ['name', 'address', 'city', 'county', 'phone'].forEach(function (name) {
      var input = form.elements[name];
      if (!input) return;
      input.addEventListener('blur', function () {
        var errs = validate(values());
        showError(name, errs[name] ? cfg.messages[name] : '');
      });
      input.addEventListener('input', function () {
        var field = fieldOf(name);
        if (field && field.classList.contains('is-invalid')) showError(name, '');
      });
    });

    /*
     * Totalul afișat = bază (produs + livrare + ramburs) + extra bifate.
     * E informativ: serverul îl recalculează independent, din prețurile
     * Shopify. Dacă cele două ar diferi, adevărul e cel din comandă.
     */
    // Rezumatul există în două copii (coloana din dreapta pe desktop, în
    // formular pe telefon). Le actualizăm pe toate: una singură e vizibilă,
    // dar care anume depinde de lățimea ecranului.
    var summaries = Array.prototype.slice.call(document.querySelectorAll('[data-zv-summary]'));
    var bumpBoxes = Array.prototype.slice.call(form.querySelectorAll('[data-zv-bump]'));
    var qtyRadios = Array.prototype.slice.call(form.querySelectorAll('[data-zv-qty-option]'));

    function money(n) {
      return (Math.round(n * 100) / 100).toString().replace('.', ',');
    }

    /**
     * Pragul de cantitate bifat, sau null când formularul nu are selector.
     *
     * Null nu e o eroare: un formular fără carduri de cantitate se comportă
     * exact ca înainte să existe, cu o bucată și fără să trimită nimic în plus.
     */
    function selectedTier() {
      for (var i = 0; i < qtyRadios.length; i++) {
        if (!qtyRadios[i].checked) continue;
        var qty = parseInt(qtyRadios[i].getAttribute('data-qty'), 10);
        var total = parseFloat(qtyRadios[i].getAttribute('data-total'));
        if (!(qty > 0) || !isFinite(total)) return null;
        return {
          qty: qty,
          total: total,
          extraLabel: qtyRadios[i].getAttribute('data-extra-label') || ''
        };
      }
      return null;
    }

    function refreshTotal() {
      var chosen = bumpBoxes.filter(function (b) { return b.checked; });
      var extra = chosen.reduce(function (sum, b) {
        return sum + (parseFloat(b.getAttribute('data-price')) || 0);
      }, 0);
      var tier = selectedTier();

      summaries.forEach(function (summary) {
        var totalEl = summary.querySelector('[data-zv-total]');
        var extraList = summary.querySelector('[data-zv-summary-extra]');
        if (!totalEl) return;

        var base = parseFloat(summary.getAttribute('data-base')) || 0;
        // Partea care NU se schimbă cu cantitatea: livrarea și taxa de ramburs.
        var fixed = parseFloat(summary.getAttribute('data-fixed')) || 0;
        var unit = base - fixed;
        var items = tier ? tier.total : unit;
        var currency = (totalEl.textContent.match(/[^\d.,\s]+$/) || [''])[0];

        if (extraList) {
          extraList.innerHTML = '';
          // Linia de extra imită stilul listei în care e inserată.
          var lineClass = extraList.className.indexOf('zv-sum__') !== -1
            ? 'zv-sum__line' : 'zv-order__line';
          var valueClass = lineClass === 'zv-sum__line' ? 'zv-sum__value' : 'zv-order__line-value';

          var addLine = function (label, value) {
            var li = document.createElement('li');
            li.className = lineClass;
            var name = document.createElement('span');
            name.textContent = label;
            var val = document.createElement('span');
            val.className = valueClass;
            val.textContent = money(value) + ' ' + currency;
            li.appendChild(name);
            li.appendChild(val);
            extraList.appendChild(li);
          };

          /*
           * Pachetele în plus, ca linie separată.
           *
           * Liniile statice din rezumat descriu UN pachet și rămân adevărate.
           * Diferența până la totalul pragului intră aici, deci suma liniilor
           * afișate dă exact totalul de jos — și se vede negru pe alb că al
           * doilea pachet costă mai puțin decât primul.
           */
          if (tier && tier.qty > 1) addLine(tier.extraLabel, items - unit);

          chosen.forEach(function (box) {
            addLine(
              box.getAttribute('data-label') || '',
              parseFloat(box.getAttribute('data-price')) || 0
            );
          });
          extraList.hidden = extraList.children.length === 0;
        }

        totalEl.textContent = money(items + fixed + extra) + ' ' + currency;
      });

      /*
       * Ce citește `tracking.js`. Fără asta, `InitiateCheckout` ar raporta
       * mereu prețul unei bucăți, chiar și după ce omul a ales trei.
       */
      window.ZV_SELECTION = {
        quantity: tier ? tier.qty : 1,
        value: tier ? tier.total : null
      };
    }

    function markQtyCards() {
      qtyRadios.forEach(function (radio) {
        var card = radio.closest('.zv-qty__card');
        if (card) card.classList.toggle('is-on', radio.checked);
      });
    }

    qtyRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        markQtyCards();
        showError('quantity', '');
        refreshTotal();
      });
    });

    /*
     * Cantitatea pornește ÎNTOTDEAUNA de la pragul cel mai mic.
     *
     * Browserele restaurează singure starea butoanelor radio la reîncărcare și
     * la întoarcerea cu „înapoi", inclusiv din bfcache. Aici asta ar însemna că
     * cine s-a uitat ieri la „3 pachete" revine azi pe pagină cu trei deja
     * bifate și comandă trei fără să vrea — iar la ramburs asta se traduce
     * direct în colet refuzat la ușă.
     *
     * `autocomplete="off"` din marcare oprește o parte din browsere; funcția
     * asta le oprește pe toate.
     */
    function resetQty() {
      var def = form.querySelector('[data-zv-qty-default]');
      if (def && !def.checked) def.checked = true;
      markQtyCards();
      refreshTotal();
    }

    resetQty();
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) resetQty();
    });

    bumpBoxes.forEach(function (box) {
      box.addEventListener('change', function () {
        box.closest('.zv-bump').classList.toggle('is-on', box.checked);
        refreshTotal();
      });
      box.closest('.zv-bump').classList.toggle('is-on', box.checked);
    });
    refreshTotal();

    function scrollToQty() {
      var box = form.querySelector('[data-zv-qty]');
      if (box && box.scrollIntoView) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function fail(message) {
      submitting = false;
      button.disabled = false;
      label.textContent = cfg.messages.submit;
      formError.textContent = message;
      if (cfg.orderPhone) {
        formError.appendChild(document.createTextNode(' '));
        var link = document.createElement('a');
        link.href = 'tel:' + String(cfg.orderPhone).replace(/\s/g, '');
        link.textContent = cfg.orderPhone;
        formError.appendChild(link);
      }
      formError.hidden = false;
      formError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (submitting) return;

      clearErrors();
      var vals = values();
      var errors = validate(vals);
      var bad = Object.keys(errors);

      if (bad.length > 0) {
        bad.forEach(function (n) { showError(n, cfg.messages[n]); });
        var first = form.elements[bad[0]];
        if (first) first.focus();
        return;
      }

      /*
       * Selector prezent dar nimic bifat. Nu se poate întâmpla din randare —
       * Liquid bifează pragul cu cele mai puține pachete — dar dacă vreodată
       * se poate, mai bine o eroare pe loc decât o comandă trimisă fără
       * cantitate, pe care serverul o tratează ca pe un singur pachet.
       */
      var tier = selectedTier();
      if (qtyRadios.length > 0 && tier === null) {
        showError('quantity', cfg.messages.quantity);
        scrollToQty();
        return;
      }

      submitting = true;
      button.disabled = true;
      label.textContent = cfg.messages.submitting;

      var payload = {
        name: vals.name,
        phone: vals.phone,
        county: vals.county,
        city: vals.city,
        address: vals.address,
        zv_hp_company: form.elements.zv_hp_company ? form.elements.zv_hp_company.value : '',
        // Prag anti-bot. Serverul recalculează; aici doar raportăm.
        renderedAt: renderedAt,
        // Doar id-uri. Prețul îl pune serverul, din Shopify.
        bumps: bumpBoxes.filter(function (b) { return b.checked; })
                        .map(function (b) { return b.value; }),
        utm: collectUtm(),
        // `variant`, nu `assigned`: primul e varianta RANDATĂ, al doilea e cea
        // atribuită de cookie. Când splitterul automat e oprit, redirectul nu
        // se face și cele două diferă — comanda ar spune „B" pentru un client
        // care a văzut pagina A, iar raportul A/B ar deveni gunoi.
        variant: (window.ZV_AB && window.ZV_AB.variant) || null,
        sourceUrl: window.location.href,
        referrer: document.referrer || null,
        // Identificatorii de click: singura punte către atribuire când
        // vizitatorul a refuzat cookie-urile și pixelul nu s-a încărcat.
        fbp: cookie('_fbp'),
        fbc: cookie('_fbc'),
        fbclid: param('fbclid'),
        ttclid: param('ttclid'),
        ttp: cookie('_ttp'),
        // Modul test. Null pentru comenzile reale, deci Purchase-ul lor intră
        // normal în raportarea Meta. Serverul verifică codul, nu-l crede.
        testCode: testCode()
      };

      /*
       * Doar numărul, niciodată prețul. Serverul are propriile praguri și
       * respinge orice cantitate care nu e printre ele.
       *
       * Când formularul nu are selector, câmpul lipsește cu totul din corp:
       * așa o pagină veche rămasă în cache comandă exact ca înainte.
       */
      if (tier) payload.quantity = tier.qty;

      fetch(cfg.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json().then(function (data) { return { status: res.status, data: data }; });
        })
        .then(function (r) {
          if (r.status === 400 && r.data.errors) {
            submitting = false;
            button.disabled = false;
            label.textContent = cfg.messages.submit;
            Object.keys(r.data.errors).forEach(function (n) {
              if (cfg.messages[n]) showError(n, cfg.messages[n]);
            });
            // Cantitatea nu e un `<input>` singur, ci un grup de radio-uri:
            // `form.elements.quantity` întoarce lista, care nu are `focus`.
            if (r.data.errors.quantity) {
              scrollToQty();
              return;
            }
            var firstBad = form.elements[Object.keys(r.data.errors)[0]];
            if (firstBad && firstBad.focus) firstBad.focus();
            return;
          }

          if (!r.data || r.data.ok !== true) {
            fail(cfg.messages.server);
            return;
          }

          /*
           * Predarea către pagina de mulțumire.
           *
           * Datele clientului le punem NOI, din formular — serverul nu le
           * ecouă înapoi. Rămân pe dispozitivul lui, în sessionStorage, și
           * mor odată cu tabul.
           *
           * Fără `eventId` (comandă duplicată sau bot), pagina nu declanșează
           * niciun Purchase.
           */
          try {
            sessionStorage.setItem(
              'zv_order',
              JSON.stringify({
                savedAt: Date.now(),
                orderName: r.data.orderName,
                // Id-ul numeric al comenzii. Îl cere Intelligems pentru
                // evenimentul `orderPlaced`: fără checkout Shopify, mecanismul
                // lui obișnuit de atribuire nu are pe ce să se agațe.
                orderId: r.data.orderId || null,
                eventId: r.data.eventId,
                value: r.data.value,
                currency: r.data.currency,
                contentId: r.data.contentId,
                contentName: r.data.contentName,
                // Cantitatea CHIAR pusă pe comandă, spusă de server. Dacă
                // pragurile din temă și cele din API s-ar despărți vreodată,
                // nepotrivirea se vede pe pagina de mulțumire, nu la ușă.
                quantity: r.data.quantity || 1,
                extras: r.data.extras || [],
                customer: {
                  name: vals.name.trim(),
                  phone: vals.phone.trim(),
                  address: vals.address.trim(),
                  city: vals.city.trim(),
                  county: r.data.county || vals.county.trim()
                }
              })
            );
          } catch (e) {
            /* mod privat: pagina de mulțumire se afișează, doar fără detalii */
          }

          window.location.assign(cfg.successUrl);
        })
        .catch(function () {
          fail(cfg.messages.network);
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
